/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export interface ChangeData<T> {
  key?: string;
  timestamp?: number;
  originalValue?: T;
  currentValue: T;
}

export class Change<T> implements ChangeData<T> {
  public readonly key: string;
  public readonly timestamp: number;
  public readonly originalValue: T;
  public readonly currentValue: T;

  constructor(data: ChangeData<T>) {
    this.key = data.key;
    this.timestamp = data.timestamp;
    this.originalValue = data.originalValue;
    this.currentValue = data.currentValue;
  }

  toJSON(): object {
    const json: ChangeData<T> = {
      originalValue: this.originalValue && typeof this.originalValue['toJSON'] === 'function'
        ? this.originalValue['toJSON']()
        : this.originalValue,
      currentValue: this.currentValue && typeof this.currentValue['toJSON'] === 'function'
        ? this.currentValue['toJSON']()
        : this.currentValue
    };
    if (this.key !== undefined) {
      json.key = this.key;
    }
    if (this.timestamp !== undefined) {
      json.timestamp = this.timestamp;
    }
    return json;
  }
}
